import {Alert, Animated, Modal, StyleSheet, Switch, Text, View} from 'react-native';
import React, {useEffect, useRef, useState} from 'react';
import ChessboardWithArrow from '@/Components/ChessboardWithArrow';
import ChessBoardLoader from '../../utils/loader/ChessBoardLoader';
import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import {FontSizes} from '@/Utils/Dimensions';
import {TouchableOpacity} from 'react-native-gesture-handler';
import CCTextInput from '@/Atoms/CCTextInput';
import CCColors from '@/Utils/CCColors';
import {Chess} from 'chess.js';
import {createPuzzle} from '../../utils/puzzle/createPuzzle';
import useCreatePuzzleApi from '@/Hooks/ClassroomInfoApi/useCreatePuzzleApi';
import useVerifyPuzzleApi from '@/Hooks/ClassroomInfoApi/useVerifyPuzzleApi';
import ClockComponent from '@/Screens/PlayChess/components/ClockComponent';
import useSound from 'use-sound';
import wrongSound from '../../../../Assets/Sounds/wrong.mp3';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import useAnimation from '@/Hooks/useAnimation';
import Spacer from '@/Atoms/Spacer';
import {PreventRemoveContext} from '@react-navigation/native';
import usePublishClassroomTestApi from '@/Hooks/ClassroomInfoApi/usePublishClassroomTestApi';
interface ActivePuzzleProps {
  meetingId: string;
  occurenceId: string;
  meetingRole: string;
  topic: string;
  currentActivePuzzle: any;
  isActiveTab: boolean;
  setActiveTabLeft: (tabIndex: number) => void;
  setSolvedActivePuzzle: (value: boolean) => void;
  source: string;
  isTestClass?: boolean;
  testBookId?: string | number;
  testBookName?: string;
  setNudgeMessage?: (message: string) => void;
  setShowNudgePopup?: (show: boolean) => void;
  mysteryCount?: number;
  onAutoStarsAwarded?: (data: any) => void;
  onMysteryActivated?: () => void;
  onMysteryRejected?: () => void;
}

const ActivePuzzle: React.FC<ActivePuzzleProps> = ({
  meetingId,
  occurenceId,
  meetingRole,
  topic,
  currentActivePuzzle,
  isActiveTab,
  setActiveTabLeft,
  setSolvedActivePuzzle,
  source,
  isTestClass,
  testBookId,
  testBookName,
  setNudgeMessage,
  setShowNudgePopup,
  mysteryCount = 0,
  onAutoStarsAwarded,
  onMysteryActivated,
  onMysteryRejected,
}) => {
  const defaultFen = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';
  // console.log('Prop rec', meetingId, occurenceId, meetingRole);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [puzzleAddedCount, setPuzzleAddedCount] = useState<number>(
    generatePuzzleNumber(),
  );
  const [role, setRole] = useState<number>(meetingRole === 'student' ? 0 : 1);
  const [isMysteryBonus, setIsMysteryBonus] = useState(false);
  console.log('role, ', role, isTestClass, testBookId, testBookName);
  const [puzzleOverModal, setPuzzleOverModal] = useState<boolean>(false);
  const countdownRef = useRef(3);
  const [countdown, setCountdown] = useState(3);
  const [isSolved, setIsSolved] = useState<boolean>(false);
  const timeoutId = useRef<any>(null);
  // const [puzStartTime, setPuzStartTime] = useState<number>(
  //   Number(currentActivePuzzle.puzzleTime),
  // );
  const [puzzleTimeOver, setPuzzleTimeOver] = useState<boolean>(false);
  const [createButton, setCreateButton] = useState<boolean>(false);
  const [createMessage, setCreateMessage] = useState<string>('');
  const [publishTestLoading, setPublishTestLoading] = useState<boolean>(false);
  console.log('Active puzzle currentActivePuzzle', currentActivePuzzle, source);

  const handleOnSuccessPublishTest = (data: any) => {
    console.log('handleOnSuccessPublishTest data?', data);
    setPublishTestLoading(false);
    setNudgeMessage?.(data?.message ?? 'Test published successfully');
    setShowNudgePopup?.(true);
  };

  const handleOnErrorPublishTest = (error: any) => {
    console.error('handleOnErrorPublishTest error?', error);
    setPublishTestLoading(false);
    setNudgeMessage?.(
      error?.response?.data?.error ??
        'Failed to publish test. Please try again.',
    );
    setShowNudgePopup?.(true);
  };

  const {mutate: publishClassroomTest} = usePublishClassroomTestApi(
    handleOnSuccessPublishTest,
    handleOnErrorPublishTest,
  );

  useEffect(() => {
    if (isSolved && timeoutId.current) {
      console.log('isSolved works here');
      clearTimeout(timeoutId.current);
      timeoutId.current = null;
    }
  }, [isSolved]);

  useEffect(() => {
    // Clean up timeout if puzzle is solved
    if (isSolved) {
      console.log('isSolved works');
      clearTimeout(timeoutId.current);
      return;
    }
    if (
      source !== 'recording' &&
      currentActivePuzzle.remainingTime === 0
      // || currentActivePuzzle.remainingTime !== currentActivePuzzle.puzzleTime
    ) {
      setCountdown(0);
      countdownRef.current = 0;
    }
    setSolvedActivePuzzle(false);
    timeoutId.current = setTimeout(() => {
      console.log('Is solved proper?', isSolved);
      // !isSolved &&
      //   source !== 'recording' &&
      //   setSelectedPuzItem(prev => ({
      //     ...prev,
      //     time: 0,
      //   }));
      if (selectedPuzItem.puzzleId && selectedPuzItem.fen)
        verifyPuzzle({
          puzzleId: selectedPuzItem.puzzleId,
          fen: selectedPuzItem.fen,
          move: 'None',
          moveCount: activeMoveCount,
          timeEnded: true,
          meetingRole: role,
          source: source,
        });
      setPuzzleTimeOver(true);
      setSolvedActivePuzzle(true);
      setPuzzleOverModal(true);
    }, (source !== 'recording' ? currentActivePuzzle.remainingTime + 4 : Number(currentActivePuzzle.puzzleTime) + 4) * 1000);
  }, [currentActivePuzzle.puzzleId, isSolved]);

  const [selectedPuzItem, setSelectedPuzItem] = useState({
    puzzleId: currentActivePuzzle.puzzleId,
    puzzleName: currentActivePuzzle.puzzleName,
    fen: currentActivePuzzle.startingFEN,
    prevfen: currentActivePuzzle.startingFEN,
    startingfen: currentActivePuzzle.startingFEN,
    orientation: currentActivePuzzle.orientation,
    time: Number(
      source === 'recording'
        ? currentActivePuzzle.puzzleTime
        : currentActivePuzzle.remainingTime,
    ),
    attempts: 0,
  });

  useEffect(() => {
    if (
      source === 'recording' &&
      selectedPuzItem?.puzzleId &&
      selectedPuzItem?.fen
    ) {
      console.log('Sending recording start verifyPuzzle call...');
      verifyPuzzle({
        puzzleId: selectedPuzItem.puzzleId,
        fen: selectedPuzItem.fen,
        move: '__start__',
        moveCount: 0,
        timeEnded: false,
        meetingRole: role || 0,
        source: source,
      });
      setActiveTabLeft(2);
    }
  }, [selectedPuzItem?.puzzleId, source]);

  const [createPuzItem, setCreatePuzItem] = useState({
    puzzleName: `${puzzleAddedCount} Puzzle ${topic}`,
    fen: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
    startingFEN: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
    orientation: 'white',
    time: '300',
  });
  const [tempPuzzle, setTempPuzzle] = useState({
    valid: 1,
    fen: defaultFen,
  });
  const [puzzleModal, setPuzzleModal] = useState<boolean>(false);
  const [activeMoveCount, setActiveMoveCount] = useState<number>(1);
  const [solution, setSolution] = useState({moveList: '', moveCount: 1});
  const [isMyTurn, setIsMyTurn] = useState<boolean>(true);
  const [timerStarted, setTimerStarted] = useState<boolean>(false);
  const [isPlayerTurn, setIsPlayerTurn] = useState<boolean>(true);
  const [result, setResult] = useState({
    text:
      (selectedPuzItem.orientation === 'black' ? 'Black' : 'White') +
      ' to play',
    isSuccess: false,
  });
  const [isVisible, setIsVisible] = useState(true);
  const [incorrectSound] = useSound(wrongSound);
  const [resultOpacityAnimStyle, startResultOpacityAnim] = useAnimation({
    prop: 'opacity',
    start: 1,
    end: 1,
    repeat: true,
    numberOfReps: 2,
    inputRange: [0, 0.1],
    duration: 1000,
  });

  const handleOpponentMove = verifyPuzzleData => {
    showSolutionFeedback(!verifyPuzzleData.incorrect, verifyPuzzleData.stop);
    if (verifyPuzzleData.stop) {
      setResult({
        text: 'Solved Puzzle successfully',
        isSuccess: true,
      });
      setIsSolved(true);
      setSolvedActivePuzzle(true);
      return;
    }
    let game;
    try {
      game = new Chess(selectedPuzItem.fen);
    } catch (error) {
      game = new Chess(defaultFen);
    }
    const possibleMoves = game.moves();
    if (possibleMoves.length > 0) {
      const opponentMove = verifyPuzzleData?.opponent_move;
      let moveResult;
      try {
        moveResult = game.move(opponentMove);
      } catch {
        // opponent_move from API is invalid for current position — skip
      }
      if (moveResult) {
        const newFen = game.fen();
        // setOpponentMoveFen(newFen);
        setSelectedPuzItem(prev => ({
          ...prev,
          previousFen: prev.fen,
          fen: newFen,
        }));
        setIsPlayerTurn(true);
        setTimeout(() => {
          setResult({
            text: `Your turn to move!`,
            isSuccess: false,
          });
        }, 500); // Adjust the delay if needed
      } else {
        // If opponent's move is not valid, stop the puzzle
        setResult({
          text: 'No more moves possible. Puzzle complete!',
          isSuccess: true,
        });
      }
    } else {
      setResult({
        text: 'No more moves possible. Puzzle complete!',
        isSuccess: true,
      });
    }
  };

  function showSolutionFeedback(isSuccess, stop = false) {
    if (isSuccess) {
      setResult({
        text: `Correct! ${
          stop ? 'Solved Puzzle successfully' : 'Please proceed with next move'
        }`,
        isSuccess: true,
      });
      if (stop) {
        setIsMyTurn(false);
        setPuzzleOverModal(true);
        setIsSolved(true);
        setSolvedActivePuzzle(true);
      }
    } else {
      setResult({
        text: 'Your move is not the best. Try again!',
        isSuccess: false,
      });
    }
    startResultOpacityAnim();
  }

  const createdWithMysteryRef = useRef<boolean>(false);

  const handleOnSuccessCreatePuzzle = data => {
    console.log('Puzzle Created Successfully', data);
    setPuzzleModal(false);
    const newAddCount = generatePuzzleNumber();
    setPuzzleAddedCount(newAddCount);
    setCreatePuzItem({
      puzzleName: `${newAddCount} Puzzle ${topic}`,
      fen: defaultFen,
      startingFEN: defaultFen,
      orientation: 'white',
      time: '300',
    });
    setCreateButton(false);
    if (createdWithMysteryRef.current) {
      if (data?.mysteryRejected) {
        setCreateMessage('Mystery limit reached (max 2 per class)');
        onMysteryRejected?.();
      } else {
        setCreateMessage('');
        onMysteryActivated?.();
      }
    } else {
      setCreateMessage('');
    }
    createdWithMysteryRef.current = false;
  };

  const handleOnErrorCreatePuzzle = data => {
    setCreateButton(false);
    setCreateMessage('Move the pieces on the board to form the solution');
  };

  const handleOnSuccessVerifyPuzzle = verifyPuzzleData => {
    console.log('VerifyPuzzle Data', verifyPuzzleData);

    if (verifyPuzzleData?.message?.trim().toLowerCase() === 'time has ended') {
      console.log('time has ended reached');
      return;
    }
    if (puzzleTimeOver) {
      return;
    }

    if (verifyPuzzleData?.valid !== 1) {
      //handle later for showing animation
      setSelectedPuzItem(prev => ({
        ...prev,
        fen: selectedPuzItem.prevfen,
        attempts: prev.attempts + 1,
      }));
    } else if (
      verifyPuzzleData?.valid === 1 &&
      verifyPuzzleData?.incorrect === 0
    ) {
      setActiveMoveCount(verifyPuzzleData?.move_count);
      handleOpponentMove(verifyPuzzleData);
      setSelectedPuzItem(prev => ({
        ...prev,
        attempts: 0,
      }));
    } else if (
      verifyPuzzleData?.valid === 1 &&
      verifyPuzzleData?.incorrect === 1
    ) {
      incorrectSound();
      setSelectedPuzItem(prev => ({
        ...prev,
        fen: selectedPuzItem.prevfen,
        attempts: prev.attempts + 1,
      }));
      setIsPlayerTurn(true);
      showSolutionFeedback(!verifyPuzzleData.incorrect, verifyPuzzleData.stop);
    }

    if (onAutoStarsAwarded && verifyPuzzleData?.valid === 1) {
      onAutoStarsAwarded(verifyPuzzleData);
    }
  };

  const handlePuzzleOverClose = () => {
    setPuzzleOverModal(false);
  };
  const {mutate: createClassroomPuzzle} = useCreatePuzzleApi(
    handleOnSuccessCreatePuzzle,
    handleOnErrorCreatePuzzle,
  );

  const {mutate: verifyPuzzle, data: verifyPuzzleData} = useVerifyPuzzleApi(
    handleOnSuccessVerifyPuzzle,
  );

  const addClassroomPuzzle = () => {
    setCreateButton(true);
    let puzzleNameDisplay = createPuzItem.puzzleName;
    if (puzzleNameDisplay.length > 40) {
      puzzleNameDisplay = puzzleNameDisplay.substring(0, 37) + '...';
    }

    createdWithMysteryRef.current = isMysteryBonus;
    createClassroomPuzzle({
      meetingId,
      occurenceId,
      moveList: solution.moveList,
      moveCount: solution.moveCount - 1,
      startingFEN: createPuzItem.startingFEN,
      puzzleName: puzzleNameDisplay,
      orientation: createPuzItem.orientation,
      puzzleTime: createPuzItem.time,
      isMysteryBonus,
    });
    setIsMysteryBonus(false);
  };

  const handleCreatePuzzle = async () => {
    let copiedPuzzle = '';
    try {
      copiedPuzzle = await navigator.clipboard.readText();
    } catch (err) {
      console.warn('Clipboard read failed; opening puzzle modal empty:', err);
    }
    console.log('It got copied', copiedPuzzle);
    setTempPuzzle(prev => ({
      ...prev,
      fen: copiedPuzzle,
    }));
    handleSetFEN(copiedPuzzle);
    setPuzzleModal(true);
  };

  const handlePieceDrop = tempPosition => {
    if (puzzleTimeOver) {
      return;
    }
    verifyPuzzle({
      puzzleId: selectedPuzItem.puzzleId,
      fen: selectedPuzItem.fen,
      move: tempPosition.san,
      moveCount: activeMoveCount,
      timeEnded: false,
      meetingRole: role,
      source: source,
    });
    console.log('handlePieceDrop', tempPosition);
    setSelectedPuzItem(prev => ({
      ...prev,
      prevfen: selectedPuzItem.fen,
      fen: tempPosition.newFen,
    }));
    setIsPlayerTurn(false);
  };

  const handleCreatePuzzlePieceDrop = tempCreate => {
    console.log('handleCreatePuzzlePieceDrop', tempCreate);
    setCreatePuzItem(prev => ({...prev, fen: tempCreate.newFen}));
    const {updatedMoveList, updatedMoveCount} = createPuzzle(
      tempCreate.from,
      tempCreate.to,
      tempCreate.san,
      solution.moveList,
      solution.moveCount,
    );
    console.log(
      'handleCreatePuzzlePieceDrop Update',
      updatedMoveList,
      updatedMoveCount,
    );
    //if (!updatedMoveList) updatedMoveList = '';
    setSolution({moveList: updatedMoveList, moveCount: updatedMoveCount});
  };

  const handleSetFEN = (copiedFEN?) => {
    let tempFEN = copiedFEN ?? tempPuzzle.fen;

    if (tempFEN.includes(' w ')) {
      const fenParts = tempFEN.split(' ');
      fenParts[5] = '10'; // Change fullmove number
      tempFEN = fenParts.join(' ');
    }

    let game;
    try {
      game = new Chess(tempFEN);
      // console.log('Game from Chess', game);
      setTempPuzzle({
        valid: 1,
        fen: game.fen(),
      });
      setSolution({moveList: '', moveCount: 1});
    } catch (error) {
      // console.log('Game from Chess from catch', game);
      game = new Chess(defaultFen);
      tempFEN === copiedFEN
        ? setTempPuzzle({
            valid: 2,
            fen: defaultFen,
          })
        : setTempPuzzle({
            valid: 0,
            fen: defaultFen,
          });
      setSolution({moveList: '', moveCount: 1});
    }
    setCreatePuzItem(prev => ({
      ...prev,
      fen: game.fen(),
      startingFEN: game.fen(),
      orientation: game._turn === 'w' ? 'white' : 'black',
    }));
    setCreateButton(false);
    setCreateMessage('');
  };

  function generatePuzzleNumber() {
    const gpn = Math.floor(1000 + Math.random() * 9000); //normal otp for puzzle number
    return gpn;
  }

  const closeBanner = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    setPuzzleModal(false);
  }, []);

  useEffect(() => {
    if (selectedPuzItem.time === 0) {
      console.log('dsad', selectedPuzItem);
      setIsPlayerTurn(false);
      // setPuzzleOverModal(true);
    }
  }, [selectedPuzItem.time]);

  useEffect(() => {
    if (selectedPuzItem.fen) {
      const intervalId = setInterval(() => {
        if (countdownRef.current > 0) {
          countdownRef.current -= 1;
          setCountdown(countdownRef.current);
        } else {
          clearInterval(intervalId);
          setTimerStarted(true);
        }
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [selectedPuzItem.fen]);

  useEffect(() => {
    if (selectedPuzItem.attempts >= 3 && verifyPuzzleData?.best_move) {
      setResult({
        text: `Solution - The best move is ${verifyPuzzleData?.best_move}`,
        isSuccess: false,
      });
    }
  }, [selectedPuzItem]);

  return (
    <View style={styles.container}>
      {isActiveTab &&
        currentActivePuzzle?.puzzleId != null &&
        currentActivePuzzle.puzzleId !== '' && (
          <Modal
            animationType="slide"
            transparent={true}
            visible={puzzleOverModal}
            onRequestClose={() => {}}>
            <View style={styles.modalOverlay}>
              <View style={styles.puzzleOverModalContent}>
                <View style={styles.modalHeader}>
                  <View style={{flex: 1}}>
                    {/* <CCText fontWeight="bold" fontSize={FontSizes[14]}>
                    Puzzle Status
                  </CCText> */}
                  </View>
                  <TouchableOpacity
                    onPress={handlePuzzleOverClose}
                    style={styles.closeButton}
                    disabled={false}>
                    {/* <Icon
                    name={'close-circle'}
                    size={30}
                    color={CCColors.Primary.lightBrown}
                  /> */}
                    <CCText style={styles.closeButtonText}>×</CCText>
                  </TouchableOpacity>
                </View>
                <View
                  style={{
                    padding: 5,
                    alignContent: 'center',
                    justifyContent: 'center',
                  }}>
                  <CCText
                    fontSize={FontSizes[18]}
                    color={CCColors.Black}
                    style={{alignItems: 'center'}}
                    fontWeight="medium">
                    {isSolved
                      ? 'You have solved the Puzzle!'
                      : 'The puzzle time has expired'}
                    {/* {selectedPuzItem.puzzleName} is over */}
                  </CCText>
                  <View
                    style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginTop: 20,
                    }}>
                    {isSolved ? (
                      <Icon
                        name="check-circle"
                        size={80}
                        color={CCColors.Green}
                      />
                    ) : (
                      <Icon
                        name="close-circle"
                        size={80}
                        color={CCColors.Red}
                      />
                    )}
                  </View>
                  <CCButton
                    style={{marginTop: 20}}
                    //contentContainerStyle={styles.bottomRowButtonStyle}
                    onPress={() => {
                      setActiveTabLeft(0);
                      handlePuzzleOverClose();
                    }}>
                    <CCText color={CCColors.Black} fontWeight="medium">
                      Go To Coach Screen
                    </CCText>
                  </CCButton>
                </View>
              </View>
            </View>
          </Modal>
        )}
      {isActiveTab &&
        currentActivePuzzle?.puzzleId != null &&
        currentActivePuzzle.puzzleId !== '' &&
        !puzzleOverModal && (
          <Modal
            animationType="slide"
            transparent={true}
            visible={!timerStarted}
            onRequestClose={() => {}}>
            <View style={styles.modalOverlay}>
              <View style={styles.puzzleStartModalContent}>
                <CCText fontWeight="bold" fontSize={FontSizes[14]}>
                  Solve in {countdown}
                </CCText>
              </View>
            </View>
          </Modal>
        )}
      <View style={styles.container2}>
        <View style={styles.titleAndTimer}>
          <CCText
            style={{
              paddingVertical: 12,
              fontFamily: 'DM Sans',
              fontWeight: '700',
            }}
            fontSize={FontSizes[14]}>
            {selectedPuzItem.puzzleName
              ? selectedPuzItem.puzzleName
              : 'No Active Puzzle to Solve'}
          </CCText>
          <ClockComponent
            timer={Number(selectedPuzItem.time)}
            myTurn={isMyTurn}
            playing={timerStarted}
            setFirstMovetimer={() => {}}
            firstMovetimer={5}
            showFirstMoveTimer={false}
          />
        </View>
        <Box style={styles.chessBoardContainer}>
          <ChessBoardLoader isLoading={isLoading}>
            <ChessboardWithArrow
              position={
                selectedPuzItem.puzzleId ? selectedPuzItem.fen : defaultFen
              }
              handleNewFen={handlePieceDrop}
              lastMoveFen={selectedPuzItem.prevfen}
              boardOrientation={selectedPuzItem.orientation}
              disabled={!isPlayerTurn}
            />
          </ChessBoardLoader>
          {isVisible && (
            <Animated.View
              style={[
                resultOpacityAnimStyle,
                {
                  backgroundColor: result.isSuccess
                    ? CCColors.Green
                    : CCColors.Red,
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: 10,
                },
              ]}>
              <Icon
                name={result.isSuccess ? 'check-circle' : 'alert-circle'}
                size={20}
                color={CCColors.White}
              />
              <CCText
                textAlign="left"
                style={[
                  styles.puzzleSolutionText,
                  {
                    color: CCColors.White,
                    flex: 1,
                    marginHorizontal: 10,
                  },
                ]}>
                {result.text}
              </CCText>
              {result.isSuccess && (
                <TouchableOpacity onPress={closeBanner}>
                  <Icon name="close-circle" size={20} color={CCColors.White} />
                </TouchableOpacity>
              )}
            </Animated.View>
          )}
        </Box>
      </View>

      <View style={styles.container3}>
        {role === 1 && (
          <View style={styles.buttonContainer}>
            <CCButton style={styles.actionButton} onPress={handleCreatePuzzle}>
              <CCText numberOfLines={1} fontSize={FontSizes[12]}>
                Create Puzzle
              </CCText>
            </CCButton>
            {isTestClass && (
              <CCButton
                style={styles.actionButton}
                onPress={() => {
                  if (!publishTestLoading) {
                    setPublishTestLoading(true);
                    publishClassroomTest({
                      meetingId: meetingId,
                      meetingRole: meetingRole,
                    });
                  }
                }}>
                <CCText numberOfLines={1} fontSize={FontSizes[12]}>
                  Publish Test
                </CCText>
              </CCButton>
            )}
          </View>
          // ) : (
          //   testBookId &&
          //   testBookName && (
          //     <CCButton
          //       style={styles.actionButton}
          //       onPress={() => {
          //         const cleanBookKey = String(testBookId ?? '').replace(
          //           /[^0-9]/g,
          //           '',
          //         );
          //         window.open(
          //           `${
          //             window.location.origin
          //           }/resources?tab=user_assignment&name=${encodeURIComponent(
          //             testBookName ?? '',
          //           )}&bookKey=${cleanBookKey}`,
          //           '_blank',
          //           'noopener,noreferrer',
          //         );
          //       }}>
          //       <CCText numberOfLines={1} fontSize={FontSizes[12]}>
          //         Test
          //       </CCText>
          //     </CCButton>
          //   )
        )}
        <Modal
          animationType="slide"
          transparent={true}
          visible={puzzleModal}
          onRequestClose={() => {
            setPuzzleModal(false);
          }}>
          <View style={styles.modalOverlay}>
            <View style={styles.modalContent}>
              <CCText
                fontSize={FontSizes[14]}
                style={{fontWeight: 'bold', marginBottom: 10}}>
                Create Puzzle Board
              </CCText>
              <View style={styles.modalBody}>
                {/* Left: Chess Board */}
                <View style={styles.modalBoardContainer}>
                  <ChessboardWithArrow
                    position={createPuzItem.fen}
                    handleNewFen={handleCreatePuzzlePieceDrop}
                    lastMoveFen={createPuzItem.fen}
                    boardOrientation={createPuzItem.orientation}
                    disabled={false}
                  />
                </View>

                {/* Right: Inputs and Buttons */}
                <View style={styles.modalRightContent}>
                  {/* Puzzle Name Input */}
                  <View style={styles.inputRow}>
                    <CCTextInput
                      fontSize={14}
                      value={createPuzItem.puzzleName}
                      style={{
                        maxHeight: 35,
                        overflow: 'hidden',
                      }}
                      placeholder="Puzzle Name"
                      onChangeText={text => {
                        setCreatePuzItem(prev => ({
                          ...prev,
                          puzzleName: text,
                        }));
                      }}
                      placeholderTextColor={CCColors.TextColor.Grey}
                    />
                  </View>

                  {/* FEN Input */}
                  <View style={styles.inputRow}>
                    <CCTextInput
                      fontSize={14}
                      value={tempPuzzle.fen}
                      style={{
                        maxWidth: 230,
                        maxHeight: 35,
                        overflow: 'hidden',
                      }}
                      placeholder="Enter FEN"
                      onChangeText={text =>
                        setTempPuzzle(prev => ({...prev, fen: text}))
                      }
                      placeholderTextColor={CCColors.TextColor.Grey}
                    />
                    <CCButton
                      style={styles.buttonStyle}
                      onPress={() => handleSetFEN()}>
                      <CCText fontSize={14}>Set FEN</CCText>
                    </CCButton>
                  </View>
                  {tempPuzzle.valid === 1 && (
                    <View
                      style={{
                        flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}>
                      <CCText
                        color={CCColors.Green}
                        fontWeight="bold"
                        style={{textAlign: 'center', marginBottom: 12}}>
                        Valid FEN... Create Solution Now
                      </CCText>
                    </View>
                  )}
                  {tempPuzzle.valid === 0 && (
                    <View
                      style={{
                        flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}>
                      <CCText
                        color={CCColors.Red}
                        fontWeight="bold"
                        style={{textAlign: 'center', marginBottom: 12}}>
                        Invalid FEN ... Set Again
                      </CCText>
                    </View>
                  )}
                  {tempPuzzle.valid === 2 && (
                    <View
                      style={{
                        flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}>
                      <CCText
                        color={CCColors.Red}
                        fontWeight="bold"
                        style={{textAlign: 'center', marginBottom: 12}}>
                        Invalid COPIED FEN ... Set Again
                      </CCText>
                    </View>
                  )}
                  {/* Orientation Select */}
                  <View style={styles.orientationRow}>
                    <CCText>Select Orientation</CCText>
                    <TouchableOpacity>
                      <CCButton
                        style={[
                          styles.buttonStyle,
                          styles.orientationButton,
                          createPuzItem.orientation === 'white' &&
                            styles.selectedOrientation,
                        ]}
                        onPress={() =>
                          setCreatePuzItem(prev => ({
                            ...prev,
                            orientation: 'white',
                          }))
                        }>
                        <CCText
                          fontSize={14}
                          color={
                            createPuzItem.orientation === 'white'
                              ? CCColors.White
                              : CCColors.TextColor.Primary
                          }>
                          White
                        </CCText>
                      </CCButton>
                    </TouchableOpacity>
                    <TouchableOpacity>
                      <CCButton
                        style={[
                          styles.buttonStyle,
                          styles.orientationButton,
                          createPuzItem.orientation === 'black' &&
                            styles.selectedOrientation,
                        ]}
                        onPress={() =>
                          setCreatePuzItem(prev => ({
                            ...prev,
                            orientation: 'black',
                          }))
                        }>
                        <CCText
                          fontSize={14}
                          color={
                            createPuzItem.orientation === 'black'
                              ? CCColors.White
                              : CCColors.TextColor.Primary
                          }>
                          Black
                        </CCText>
                      </CCButton>
                    </TouchableOpacity>
                  </View>
                  <View style={styles.inputRow}>
                    <CCText>Select Time</CCText>
                  </View>
                  <View style={styles.inputRow}>
                    <CCButton
                      style={[
                        styles.buttonStyle,
                        styles.orientationButton,
                        createPuzItem.time === '30' &&
                          styles.selectedOrientation,
                      ]}
                      onPress={() =>
                        setCreatePuzItem(prev => ({
                          ...prev,
                          time: '30',
                        }))
                      }>
                      <CCText
                        fontSize={FontSizes[13]}
                        color={
                          createPuzItem.time === '30'
                            ? CCColors.White
                            : CCColors.TextColor.Primary
                        }>
                        30s
                      </CCText>
                    </CCButton>
                    <CCButton
                      style={[
                        styles.buttonStyle,
                        styles.orientationButton,
                        createPuzItem.time === '60' &&
                          styles.selectedOrientation,
                      ]}
                      onPress={() =>
                        setCreatePuzItem(prev => ({
                          ...prev,
                          time: '60',
                        }))
                      }>
                      <CCText
                        fontSize={FontSizes[13]}
                        color={
                          createPuzItem.time === '60'
                            ? CCColors.White
                            : CCColors.TextColor.Primary
                        }>
                        1min
                      </CCText>
                    </CCButton>
                    <CCButton
                      style={[
                        styles.buttonStyle,
                        styles.orientationButton,
                        createPuzItem.time === '180' &&
                          styles.selectedOrientation,
                      ]}
                      onPress={() =>
                        setCreatePuzItem(prev => ({
                          ...prev,
                          time: '180',
                        }))
                      }>
                      <CCText
                        fontSize={FontSizes[13]}
                        color={
                          createPuzItem.time === '180'
                            ? CCColors.White
                            : CCColors.TextColor.Primary
                        }>
                        3min
                      </CCText>
                    </CCButton>
                  </View>
                  <View style={styles.inputRow}>
                    <CCButton
                      style={[
                        styles.buttonStyle,
                        styles.orientationButton,
                        createPuzItem.time === '300' &&
                          styles.selectedOrientation,
                      ]}
                      onPress={() =>
                        setCreatePuzItem(prev => ({
                          ...prev,
                          time: '300',
                        }))
                      }>
                      <CCText
                        fontSize={FontSizes[12]}
                        color={
                          createPuzItem.time === '300'
                            ? CCColors.White
                            : CCColors.TextColor.Primary
                        }>
                        5min
                      </CCText>
                    </CCButton>
                    <CCButton
                      style={[
                        styles.buttonStyle,
                        styles.orientationButton,
                        createPuzItem.time === '600' &&
                          styles.selectedOrientation,
                      ]}
                      onPress={() =>
                        setCreatePuzItem(prev => ({
                          ...prev,
                          time: '600',
                        }))
                      }>
                      <CCText
                        fontSize={FontSizes[12]}
                        color={
                          createPuzItem.time === '600'
                            ? CCColors.White
                            : CCColors.TextColor.Primary
                        }>
                        10min
                      </CCText>
                    </CCButton>
                    <CCButton
                      style={[
                        styles.buttonStyle,
                        styles.orientationButton,
                        createPuzItem.time === '900' &&
                          styles.selectedOrientation,
                      ]}
                      onPress={() =>
                        setCreatePuzItem(prev => ({
                          ...prev,
                          time: '900',
                        }))
                      }>
                      <CCText
                        fontSize={FontSizes[12]}
                        color={
                          createPuzItem.time === '900'
                            ? CCColors.White
                            : CCColors.TextColor.Primary
                        }>
                        15min
                      </CCText>
                    </CCButton>
                  </View>
                  {/* Mystery Bonus toggle — coach only, max 2 per class */}
                  {role === 1 && (
                    <View style={{
                      flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between',
                      paddingVertical: 10, borderTopWidth: 1, borderTopColor: 'rgba(38,35,34,0.12)',
                      marginTop: 8,
                    }}>
                      <View style={{flexDirection: 'row', alignItems: 'center', gap: 8, flex: 1}}>
                        <Text style={{fontSize: 16}}>🎁</Text>
                        <View>
                          <CCText fontSize={FontSizes[12]} fontWeight="bold">Mystery Bonus</CCText>
                          <CCText fontSize={FontSizes[11]} color={CCColors.TextColor.Grey}>
                            {mysteryCount >= 2 && !isMysteryBonus
                              ? '2/2 used — limit reached'
                              : isMysteryBonus
                                ? `Correct solve = 3× stars · ${mysteryCount + 1}/2 used`
                                : `Make this a 3× stars puzzle · ${mysteryCount}/2 used`}
                          </CCText>
                        </View>
                      </View>
                      <Switch
                        value={isMysteryBonus}
                        onValueChange={setIsMysteryBonus}
                        disabled={mysteryCount >= 2 && !isMysteryBonus}
                        trackColor={{false: 'rgba(38,35,34,0.18)', true: '#937ADB'}}
                        thumbColor="#fff"
                      />
                    </View>
                  )}

                  <View style={styles.bottomRow}>
                    <CCButton
                      style={{marginTop: 15}}
                      contentContainerStyle={styles.bottomRowButtonStyle}
                      onPress={() => setPuzzleModal(false)}>
                      <CCText>Close</CCText>
                    </CCButton>
                    <CCButton
                      style={{marginTop: 15}}
                      contentContainerStyle={styles.bottomRowButtonStyle}
                      onPress={addClassroomPuzzle}
                      disabled={createButton}>
                      <CCText>Add Puzzle</CCText>
                    </CCButton>
                  </View>
                  <View
                    style={{
                      alignItems: 'center',
                      paddingTop: 3,
                    }}>
                    <CCText color={CCColors.Red} fontWeight="bold"></CCText>
                    <CCText color={CCColors.Red} fontWeight="bold">
                      {createMessage}
                    </CCText>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </Modal>
      </View>
    </View>
  );
};

export default ActivePuzzle;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    // width: '65%',
  },
  container2: {
    flex: 1,
    flexDirection: 'column',
    paddingLeft: 30,
    paddingRight: 20,
  },
  chessBoardContainer: {
    flex: 1,
    aspectRatio: 1,
    maxWidth: 400,
    maxHeight: 400,
    alignSelf: 'center',
  },
  container3: {
    flexDirection: 'column',
    flex: 1,
    paddingVertical: 20,
  },
  buttonContainer: {
    gap: 12,
  },
  actionButton: {
    maxWidth: '50%',
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    width: '90%',
    maxWidth: 800,
    backgroundColor: '#fff',
    padding: 20,
    borderRadius: 10,
    elevation: 10,
    flexWrap: 'wrap',
  },
  modalBody: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 20,
    flexWrap: 'wrap',
  },
  modalBoardContainer: {
    width: 350,
    aspectRatio: 1,
    flexShrink: 0,
  },
  modalRightContent: {
    flex: 1,
    justifyContent: 'space-between',
  },
  titleAndTimer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 10,
    paddingVertical: 5,
  },
  inputRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    flexWrap: 'wrap',
  },
  bottomRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  bottomRowButtonStyle: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center', // optional, to center the button horizontally
    width: 180,
  },
  buttonStyle: {
    marginLeft: 10,
    maxWidth: '100%',
  },
  orientationRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
    flexWrap: 'wrap',
    // paddingHorizontal: 10,
    // justifyContent: 'space-between', // Distribute space between the label and buttons
  },
  orientationButton: {
    // paddingVertical: 10,
    // paddingHorizontal: 20,
    borderWidth: 1,
    borderColor: CCColors.Primary.Brown, // Default border color
    borderRadius: 5,
    // alignItems: 'center',
    // justifyContent: 'center',
    backgroundColor: CCColors.Primary.lightYellow,
    maxWidth: 110,
  },
  selectedOrientation: {
    backgroundColor: CCColors.Primary.Brown,
  },
  puzzleStartModalContent: {
    width: '20%', // Responsive width
    maxWidth: 300, // Limit the maximum width
    backgroundColor: '#fff',
    padding: 20,
    borderRadius: 10,
    elevation: 10, // Shadow for Android
    alignItems: 'center', // Center horizontally
    justifyContent: 'center', // Center vertically
    shadowColor: '#000', // Shadow for iOS
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.25,
    shadowRadius: 4,
  },
  puzzleOverModalContent: {
    width: '50%', // Responsive width
    maxWidth: 400, // Limit the maximum width
    backgroundColor: '#fff',
    padding: 20,
    borderRadius: 10,
    elevation: 10, // Shadow for Android
    alignItems: 'center', // Center horizontally
    justifyContent: 'center', // Center vertically
    shadowColor: '#000', // Shadow for iOS
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.25,
    shadowRadius: 4,
  },
  puzzleSolutionText: {
    margin: 0,
    fontSize: 15,
    fontWeight: '500',
  },
  containerHeading: {
    marginBottom: 10,
    marginTop: 10,
    fontSize: 24,
    fontWeight: '500',
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingBottom: 20,
  },
  closeButton: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  // closeButtonText: {
  //   color: CCColors.DarkGrey,
  //   backgroundColor: CCColors.Primary.lightYellow,
  //   fontSize: 25,
  //   borderCurve: 'circular',
  //   borderColor: CCColors.Primary.lightYellow,
  // },
  closeButtonText: {
    color: CCColors.Primary.Brown,
    backgroundColor: CCColors.Primary.lightYellow,
    fontSize: 25,
    border: `2px solid ${CCColors.Primary.lightYellow}`,
    borderRadius: 50,
    width: 30,
    height: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: 0,
  },
});
